
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
    props: {
        conData: {
            type: [String, Object, Array],
        },
    },
    data() {
        return {
            componentKey: 0,
            content: '',
            isMarketHighComment: false, // newsType1 급등락종목사유분석 구분값
        }
    },
    computed: {
        ...mapState ({
            MEMBER_INFO : state => state.member.memberInfo,
        }),
    }, 
    watch: {
        conData() {
            // 플리커링 때문에 임시 주석 처리
            this.contentDfilter()
            // this.forceRerender()
        },
    },
    methods: {
        // 하위 컴포넌트 렌더링 문제
        forceRerender() {
            this.componentKey += 1
        },

        // 22.11.04 suye 수정 
        // 22.04.15 suye 기간제한일자 반환 함수: 오늘일자 - num => 기준일자 
        limitDateMaker(num){
            // 현재일자  
            const today = new Date();
            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);

            // 현재일자 기준 -n일
            const dateLimit = new Date(year, Number(month)-1, day) 

            dateLimit.setDate(dateLimit.getDate() - num)

            // let limited = dateLimit.toLocaleDateString().replace(/\./g, '').replace(/(\s*)/g, "") // 일자 yyyyMMdd
            let limited = dateLimit.toLocaleDateString()
            // console.log('limited', limited)
            const changed = []
            const final = []
            if(limited.includes('.')){
                const splited = limited.split('.')
                if(splited.indexOf('') !== -1) splited.splice(splited.indexOf(''))
                // console.log('splited', splited)
                splited.forEach(e => {
                    changed.push(e.trim())
                });
            }
            if(changed && changed.length > 0){
                changed.forEach(e => {
                    if(e.length === 1){
                        e = '0'+e
                    }
                    final.push(e)
                });
            // console.log('final', final)
            }
            limited = final.join('')
            console.log('limited', limited)

            return limited
        },

        // 22.04.15 suye 컨텐츠 필터링 함수로 따로 뺌 
        contentDataFilter(){
            const co = '' + this.conData.content
            // 20210831 shb
            // 가져오는 데이터의 style 상위 요소에 적용되어 style 제거 | 해당 관련 style 은 resHtml.css 파일에 정의 되어있음
            // this.conData.content = co.replace(/<style>((.|\n)*?)<\/style>/g, '')
            // alert(co.replace(/<style>.*<\/style>/g, ''))
            // 20211022 shb 줄바꿈 적용안되어 추가
            this.conData.content = co
                .replace(/<style>((.|\n)*?)<\/style>/g, '')
                .replace(/&lt;br&gt;/g, '<br/>')
            console.log('content: ', this.conData)

        },

        contentDfilter() {
            /* 
                220322 meej conDate[0] 있는경우 \n -> <br/> 처리
            */
            if(this.conData[0] !== undefined){
                // 20220407 kangwook 엔터많아서
                // 22.05.10 suye 메뉴에 따른 과도한 줄바꿈 수정 
                if(this.conData[0].newsType1 === 'MARKET_AFTER_ISSUE' || this.conData[0].newsType1 === 'MARKET_BEFORE_ISSUE'){ // 일간 뉴스 클리핑 
                    this.conData[0].content = this.conData[0].content.replaceAll('\n', '<br/>').replaceAll('<br /><br/><br /><br/>', '<br><br>')
                    // 220901 meej 일간뉴스 클리핑 링크 위 본문의 등락률에 색 표시 추가
                    this.conData[0].content = this.setColor(this.conData[0].content)
                } else if(this.conData[0].newsType1 === 'MARKET_HIGH_COMMENT'){ // 급등락 종목 사유 분석
                    this.conData[0].content = this.conData[0].content.replaceAll('\n', '<br/>').replaceAll('<br /><br/>', '<br>').replaceAll('<br><br><br>', '<br>')
                    this.isMarketHighComment = true
                    
                    // 22.06.28 suye 급등락사유분석 url 링크걸기 
                    const limit = /(http(s)?:\/\/|www.)([/a-z0-9-%#?&=\w]+\.*)+[a-z0-9]{2,4}([/a-z0-9-%#?&=;\w])+(\.[a-z0-9]{2,4}(\?[/a-z0-9-%#?&=;\w]+(?![^<]*?<\/br\/>))*)*/gi
                    // const limit = /(http(s)?:\/\/|www.)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}([/a-z0-9-%#?&=\w])+(\.[a-z0-9]{2,4}(\?[/a-z0-9-%#?&=;\w]+)*)*/gi
                    const test = this.conData[0].content.match(limit) // url 정규식 거르기
                    // console.log('test', test)
                    // console.log('original text: ', this.conData[0].content)

                    // 정규식으로 걸러야하는 url이 존재할 경우 
                    if (test !== null){
                        test.forEach(e => {
                            this.conData[0].content = this.conData[0].content.replaceAll(e, ('<a target="_blank" href="' + e + '">' + e +'</a>'))    
                        });
                        // console.log('after: ', this.conData[0].content)
                        const removedText = []
                        // <a>태그가 잘못들어가는 경우 
                        // ex. <a target="_blank" href="<a target=" _blank"="">https:</a>
                        if(this.conData[0].content.includes('href="<a target="_blank"')){
                            let splitText = [] 
                            splitText = this.conData[0].content.split('<br>') // 줄바꿈 기준으로 텍스트 분리 
                            // console.log('splitText', splitText)
                            splitText.forEach(e => { 
                                let cut = []
                                let textConcat = ''
                                e = '<br>'+e
                                if(e.includes('href="<a target="_blank" ')){ // 문제의 a태그 소거 
                                    console.log('caught e :', e)
                                    e = e.replaceAll('<a target="_blank" href="<a target="_blank" ', '-cut-(deleteText)').replaceAll('</a>">', '-cut-')
                                    console.log('changed e :', e)
                                    cut = e.split('-cut-').filter(e => !e.includes('(deleteText)'))
                                    // console.log('cut', cut)
                                    cut.forEach(text => {
                                        textConcat = textConcat.concat(text) 
                                        e = textConcat
                                        // console.log('textConcat ', e)
                                    });
                                }
                            removedText.push(e)    
                            });
                            // console.log('includes', removedText)
                            let stringTemp = ''
                            removedText.forEach(e => {
                                stringTemp = stringTemp.concat(e)
                            });
                            this.conData[0].content = stringTemp
                        } 
                    }                  
                    
                } else if(this.conData[0].newsType1 === 'MARKET_FLASH_AM_FEATURED_KOSDAQ' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_AM_FEATURED_KOSPI' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_PM_FEATURED_KOSPI' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_PM_FEATURED_KOSDAQ' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_THEME_AM' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_THEME_PM' 
                    ){
                    /* 220516 meej 장중 특징주 및 특징테마 추가 */
                    const co = '' + this.conData[0].content
                    this.conData[0].content = co
                        .replace(/<style>((.|\n)*?)<\/style>/g, '')
                        .replace(/&lt;br&gt;/g, '<br/>')
                } else {
                    this.conData[0].content = this.conData[0].content.replaceAll('\n', '<br/>')
                }
            }else{
                this.contentDataFilter()
            }
        },
        // 220901 meej 일간뉴스 클리핑 링크 위 본문의 등락률에 색 표시 추가
        setColor(content){
            const regex = new RegExp('(?<=\\()[\\-\\+].+?(?=\\))', 'g')
            const result = content.match(regex)
            if (result !== null) {
                result.forEach((el) => {
                    if (el.includes('%')) {
                        if (el.charAt(0) === '+') {
                            const tagStr = `<nobr style="color: red">${el}</nobr>`
                            content = content.replaceAll(el, tagStr)
                        } else if (el.charAt(0) === '-') {
                            const tagStr = `<nobr style="color: blue">${el}</nobr>`
                            content = content.replaceAll(el, tagStr)
                        }
                    }
                })
            }
            return content
        }
    },
}
